const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export const normalizeDateString = (dateString, asLocal = false) => {
    // unless we explicitly want to parse the datetime as in user local timezone
    // (usually the case for date only values), then utc is assumed
    const tzDesignator = asLocal ? '' : 'Z';
    if (dateString.includes('T')) {
        // `YYYY-MM-DDTHH:mm:ss` or `YYYY-MM-DDTHH:mm:ss.sssZ`
        return dateString.includes('+', 19) ||
            dateString.includes('-', 19) ||
            dateString.includes('Z', 19)
            ? dateString
            : dateString + tzDesignator;
    }
    else {
        // `YYYY-MM-DD` or `YYYY-MM-DD HH:mm:ss`
        const [date, time = '00:00:00'] = dateString.split(' ');
        return `${date}T${time}${tzDesignator}`;
    }
};
export const validateDate = (date) => {
    // if date is Date object already, clone it to avoid mutation
    const dateObj = date instanceof Date ? new Date(date.getTime()) : new Date(date);
    return dateObj.getTime() ? dateObj : null;
};
export const validateDateFormat = (date) => {
    // regex forces specific input format, performing only the basic test (w/o month/year specifics)
    if (!/^((19|2[0-9])[0-9]{2})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/.test(date))
        return false;
    // this makes sure that e.g. 2021-04-31 or 2021-02-29 don't pass
    const [year, month, day] = date.split('-');
    if (+month === 2) {
        if (+year % 4 === 0)
            return +day <= 29;
        return +day <= 28;
    }
    if ([4, 6, 9, 11].includes(+month))
        return +day <= 30;
    return true;
};
/**
 * MM-dd-yyyy
 */
export const validateMMDDYYYYDateFormat = (dateStr) => {
    const regex = /^\d{2}-\d{2}-\d{4}$/;
    if (dateStr.match(regex) === null) {
        return false;
    }
    const [month, day, year] = dateStr.split('-');
    // 👇️ format Date string as `yyyy-mm-dd`
    const isoFormattedStr = `${year}-${month}-${day}`;
    const date = new Date(isoFormattedStr);
    const timestamp = date.getTime();
    if (typeof timestamp !== 'number' || Number.isNaN(timestamp) || +year < 1900 || +year > 2999) {
        return false;
    }
    return date.toISOString().startsWith(isoFormattedStr);
};
export const validateMonthFormat = (month) => /^((19|2[0-9])[0-9]{2})-(0[1-9]|1[012])$/.test(month);
export const validateTimeFormat = (time) => /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(time);
export const formatDate = (date) => {
    const dateObj = validateDate(date);
    if (!dateObj)
        return 'Invalid Date';
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    const day = dateObj.getDate();
    return `${month} ${day}, ${year}`;
};
export const formatShortDate = (date) => {
    const dateObj = validateDate(date);
    if (!dateObj)
        return 'Invalid Date';
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
};
export const formatDateTime = (date) => {
    const dateObj = validateDate(date);
    if (!dateObj)
        return 'Invalid Date';
    const shortDate = formatShortDate(dateObj);
    const hours24 = dateObj.getHours();
    const period = hours24 < 12 ? 'AM' : 'PM';
    const hours12 = hours24 === 0 ? 12 : hours24 > 12 ? hours24 - 12 : hours24;
    const hours = String(hours12).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    return `${shortDate} at ${hours}:${minutes} ${period}`;
};
export const addDays = (days, date) => {
    const dateObj = date ? validateDate(date) : new Date();
    if (!dateObj)
        return 'Invalid Date';
    dateObj.setDate(dateObj.getDate() + days);
    return formatDate(dateObj);
};
export const dayDiff = (date1, date2) => {
    const dateObj1 = validateDate(date1);
    const dateObj2 = validateDate(date2);
    if (!dateObj1 || !dateObj2)
        return NaN;
    const midnightDate1 = new Date(dateObj1.getFullYear(), dateObj1.getMonth(), dateObj1.getDate()).getTime();
    const midnightDate2 = new Date(dateObj2.getFullYear(), dateObj2.getMonth(), dateObj2.getDate()).getTime();
    return Math.floor((midnightDate1 - midnightDate2) / (1000 * 60 * 60 * 24));
};
//# sourceMappingURL=index.js.map